import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { MenuItem } from "@mui/material";
import { MenuButton } from "./MenuButton.js";
export function SubMenuItem({ label, children, ...menuButtonProps }) {
    return (_jsx(MenuButton, { menuProps: {
            anchorOrigin: { horizontal: "right", vertical: "top" },
            transformOrigin: {
                vertical: "top",
                horizontal: "left",
            },
        }, Button: _jsxs(MenuItem, { disableRipple: true, onClick: (event) => {
                event.stopPropagation();
            }, style: { alignItems: "center", justifyContent: "space-between" }, children: [label, _jsx(ChevronRightIcon, {})] }), ...menuButtonProps, children: children }));
}
//# sourceMappingURL=SubMenuItem.js.map